export class PaginationRequest {
    id?: string
    parentId?: string
    pageNo?: number
    pageSize?: number
    searchString?: string
    sourcePlatform?: string
    isActive?: boolean
    allergenType?: number
    status?: number
    statuses?: number[]
    typeFilter?: string
    foodGroupIds?: number[]
    faoFoodGroupIds?: number[]
    seasonIds?: number[]
    dataSource?: string
    ingredientStatus?: string
    statusFilter?: string[]
    dietaryPreferenceFilter?: string[]
    healthColorCodeFilter?: string[]
    productTypeFilter?: string[]
    createdFrom?: string
    createdTo?: string
    makerEmails?: string[]
    checkerEmails?: string[]
    brandNames?: string[]
    dataSourceNames?: string[]
    databaseSourceNames?: string[]
    sourceTab?: string
    priorityFilter?: string[]
    dueDateFrom?: string
    dueDateTo?: string
    isVeg?: boolean
    mealPreference?: string
    mealPreferenceIds?: number[]
    healthColorCodeIds?: number[]
    allergenIds?: number[]
    intoleranceIds?: number[]
    rawTypeIds?: number[]
    itemTypeIds?: number[]
    itemCategoryIds?: number[]
    nutrientTagIds?: number[]
    nutrientGroupIds?: number[]
    fssaiNutrientTagMasterIds?: number[]
    hasImage?: boolean
    nutrientSortBy?: string
    nutrientSortDirection?: string
    nutrientBasis?: string
    duplicatesOnly?: boolean
}
